import { ELevelResult } from 'Shared/types';
import FiltersGLR from './FiltersGLR/Filters.container';
import FiltersVLR from './FiltersVLR/Filters.container';
import FiltersPLR from './FiltersPLR/Filters.container';
export default {
    [ELevelResult.Gene]: FiltersGLR,
    [ELevelResult.Variant]: FiltersVLR,
    [ELevelResult.Phenotype]: FiltersPLR,
};
